import React from 'react'
import SimpleTable from 'components/Tables/SimpleTable'
import LoadingOverlay from 'components/Loading/LoadingOverlay'

export default ({ number, loading }) => (
  <div>
    {loading && <LoadingOverlay />}
    <SimpleTable>
      <div>
        <div>Phone:</div>
        <div>{number && (number.twilioFlowService || number.number)}</div>
      </div>
    </SimpleTable>
  </div>
)



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/IncomingWebhook/IncomingWebhookDisplay.jsx